export default __webpack_public_path__ + "static/media/fav.2d1ce502.png";